import {
  HOME_LOAD_INSTALLED_PLUGIN_BEGIN,
  HOME_LOAD_INSTALLED_PLUGIN_SUCCESS,
  HOME_LOAD_INSTALLED_PLUGIN_FAILURE,
  HOME_LOAD_INSTALLED_PLUGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadInstalledPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_INSTALLED_PLUGIN_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_INSTALLED_PLUGIN_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_INSTALLED_PLUGIN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadInstalledPluginError() {
  return {
    type: HOME_LOAD_INSTALLED_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_INSTALLED_PLUGIN_BEGIN:
      return {
        ...state,
        loadInstalledPluginPending: true,
        loadInstalledPluginError: null,
      };

    case HOME_LOAD_INSTALLED_PLUGIN_SUCCESS:
      return {
        ...state,
        loadInstalledPluginPending: false,
        loadInstalledPluginError: null,
        iPlugins: action.data ? action.data : [],
      };

    case HOME_LOAD_INSTALLED_PLUGIN_FAILURE:
      return {
        ...state,
        loadInstalledPluginPending: false,
        loadInstalledPluginError: action.data.error,
      };

    case HOME_LOAD_INSTALLED_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        loadInstalledPluginError: null,
      };

    default:
      return state;
  }
}
